define([
    "underscore",
    "backbone",
    "backbone.form"
], function(_, Backbone) {
    return Backbone.Model.extend({
        url: "/rest_login/password",
        idAttribute: 'mt4_account_no'
    });
});
